(function () {
  'use strict';

  var page = document.querySelector('.page-certification');
  if (!page) return;

  function disclosureContent(button) {
    var id = button.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function setDisclosureState(button, expanded) {
    var content = disclosureContent(button);
    if (!content) return;

    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    content.classList.toggle('mobile-hidden', !expanded);

    var visibleLabel = button.querySelector('[data-certification-disclosure-label]');
    if (visibleLabel) visibleLabel.textContent = expanded ? 'Read Less' : 'Read More';

    var accessibleLabel = expanded ? button.dataset.expandedLabel : button.dataset.collapsedLabel;
    if (accessibleLabel) button.setAttribute('aria-label', accessibleLabel);
  }

  function closeDialog(dialog) {
    if (!dialog) return;

    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      dialog.dispatchEvent(new Event('close'));
    }
  }

  function finishDialogClose(dialog) {
    var trigger = dialog._certificationTrigger;
    dialog.hidden = true;
    dialog.removeAttribute('open');
    dialog.style.removeProperty('left');
    dialog.style.removeProperty('top');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      if (document.contains(trigger)) {
        try {
          trigger.focus({ preventScroll: true });
        } catch (error) {
          trigger.focus();
        }
      }
    }

    dialog._certificationTrigger = null;
  }

  function positionDialog(dialog, trigger) {
    var edge = 16;
    var horizontalOffset = 10;
    var gap = 10;
    var triggerRect = trigger.getBoundingClientRect();

    dialog.style.setProperty('left', Math.max(edge, triggerRect.left - horizontalOffset) + 'px', 'important');
    dialog.style.setProperty('top', Math.max(edge, triggerRect.bottom + gap) + 'px', 'important');

    var dialogRect = dialog.getBoundingClientRect();
    var maxLeft = Math.max(edge, window.innerWidth - dialogRect.width - edge);
    var maxTop = Math.max(edge, window.innerHeight - dialogRect.height - edge);
    var left = Math.min(Math.max(edge, triggerRect.left - horizontalOffset), maxLeft);
    var top = triggerRect.bottom + gap;

    if (top > maxTop && triggerRect.top - dialogRect.height - gap >= edge) {
      top = triggerRect.top - dialogRect.height - gap;
    }

    dialog.style.setProperty('left', left + 'px', 'important');
    dialog.style.setProperty('top', Math.min(Math.max(edge, top), maxTop) + 'px', 'important');
  }

  function openDialog(trigger, showFocusIndicator) {
    var dialogId = trigger.getAttribute('aria-controls');
    var dialog = dialogId ? document.getElementById(dialogId) : null;
    if (!dialog) return;

    page.querySelectorAll('[data-certificate-dialog][open]').forEach(function (openDialogElement) {
      if (openDialogElement !== dialog) closeDialog(openDialogElement);
    });

    dialog._certificationTrigger = trigger;
    dialog.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');

    var triggerRect = trigger.getBoundingClientRect();
    dialog.style.setProperty('left', Math.max(16, triggerRect.left - 10) + 'px', 'important');
    dialog.style.setProperty('top', Math.max(16, triggerRect.bottom + 10) + 'px', 'important');

    if (typeof dialog.show === 'function') {
      if (!dialog.open) dialog.show();
    } else {
      dialog.setAttribute('open', '');
    }

    window.requestAnimationFrame(function () {
      positionDialog(dialog, trigger);
      var closeButton = dialog.querySelector('[data-certificate-dialog-close]');
      var focusTarget = closeButton || dialog;

      if (closeButton) {
        closeButton.classList.toggle('cert-popup-close--pointer-focus', !showFocusIndicator);
        if (!showFocusIndicator) {
          closeButton.addEventListener('blur', function clearPointerFocusStyle() {
            closeButton.classList.remove('cert-popup-close--pointer-focus');
          }, { once: true });
        }
      }

      try {
        focusTarget.focus({ preventScroll: true });
      } catch (error) {
        focusTarget.focus();
      }
    });
  }

  page.addEventListener('click', function (event) {
    var disclosureButton = event.target.closest('[data-certification-disclosure]');
    if (disclosureButton && page.contains(disclosureButton)) {
      setDisclosureState(disclosureButton, disclosureButton.getAttribute('aria-expanded') !== 'true');
      return;
    }

    var dialogTrigger = event.target.closest('[data-certificate-dialog-trigger]');
    if (dialogTrigger && page.contains(dialogTrigger)) {
      openDialog(dialogTrigger, event.detail === 0);
      return;
    }

    var closeButton = event.target.closest('[data-certificate-dialog-close]');
    if (closeButton && page.contains(closeButton)) {
      closeDialog(closeButton.closest('[data-certificate-dialog]'));
    }
  });

  page.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var dialog = page.querySelector('[data-certificate-dialog][open]');
    if (dialog) {
      event.preventDefault();
      closeDialog(dialog);
    }
  });

  page.querySelectorAll('[data-certificate-dialog]').forEach(function (dialog) {
    dialog.addEventListener('close', function () {
      finishDialogClose(dialog);
    });
  });

  window.addEventListener('resize', function () {
    var dialog = page.querySelector('[data-certificate-dialog][open]');
    if (dialog && dialog._certificationTrigger) {
      positionDialog(dialog, dialog._certificationTrigger);
    }
  });
})();